module.exports = __webpack_public_path__ + "img/tabbed-search-filter-default.f0374485.png";